import styled from 'styled-components';

export const InfoSection = styled.div`    
    background-position: center;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-image: url(wallpaper.png);
`;

export const Background = styled.div`
    width: 100%;
    height: 100%;
    background-color: #00000099;
    position: relative;
`;

export const BackgroundWrapper = styled.div`
   background-color: #00000040;
`;
